import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncAddPricing = createAsyncThunk(
  "/fetchAsyncAddPricing",
  async (data) => {
    try {
      const response = await axiosInstance.post('/pricing/add', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUpdatePricing = createAsyncThunk(
  "/fetchAsyncUpdatePricing",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/pricing/update/${data.id}`, data.editData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetPricing = createAsyncThunk(
  "/fetchAsyncGetPricing",
  async () => {
    try {
      let url = `${API_URL}/pricing/get`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


const AllPricingSlice = createSlice({
  name: "pricingData",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncGetPricing.pending]: (state) => {},
    [fetchAsyncGetPricing.fulfilled]: (state, { payload }) => {
      return payload;
    },
  },
});

export const getAllPricing = (state) => state.pricingData;

export default AllPricingSlice.reducer;
